import { Seo } from "../components/Seo";
import React, { useEffect } from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { ArrowLeft } from "lucide-react";
import { LEGAL } from "../legalData";
import { INFO_EMAIL } from "../mock";

const ORDER = ["privacy-policy", "terms-of-service"];

const Legal = () => {
  const { slug } = useParams();
  const doc = LEGAL[slug];

  useEffect(() => {
    if (doc) document.title = `${doc.title} — Fleetroot`;
    return () => {
      document.title = "Fleetroot — Fleet management & last-mile delivery, simplified.";
    };
  }, [doc]);

  if (!doc) return <Navigate to="/legal/privacy-policy" replace />;

  const updated = new Date(doc.updated).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });

  return (
    <article className="pt-12 md:pt-16 pb-24" data-testid={`legal-${slug}`}>
      <Seo title={doc.title} description={`Fleetroot ${doc.title.toLowerCase()}. Last updated ${updated}.`} />
      <div className="container-x max-w-[820px]">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm font-medium text-[var(--fr-muted)] hover:text-[var(--fr-ink)]">
          <ArrowLeft size={15} /> Back to home
        </Link>

        <div className="mt-6 flex flex-wrap gap-2" data-testid="legal-tabs">
          {ORDER.map((k) => (
            <Link
              key={k}
              to={`/legal/${k}`}
              className={`h-9 px-4 inline-flex items-center rounded-full text-sm font-medium border transition-colors ${
                k === slug
                  ? "bg-[var(--fr-ink)] text-white border-[var(--fr-ink)]"
                  : "bg-white text-[var(--fr-ink-2)] border-[var(--fr-border)] hover:border-[var(--fr-ink)]"
              }`}
              data-testid={`legal-tab-${k}`}
            >
              {LEGAL[k].title}
            </Link>
          ))}
        </div>

        <span className="eyebrow-pill mt-10 inline-flex">Legal</span>
        <h1 className="font-display font-bold tracking-tight leading-[1.08] text-3xl md:text-5xl mt-5" data-testid="legal-title">
          {doc.title}
        </h1>
        <p className="mt-3 text-sm text-[var(--fr-muted)]">Last updated {updated}</p>

        <div className="prose-fr mt-10" data-testid="legal-body">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{doc.content}</ReactMarkdown>
        </div>

        <div className="mt-14 card p-6 text-[15px] text-[var(--fr-ink-2)]">
          Questions about this document? Email{" "}
          <a href={`mailto:${INFO_EMAIL}`} className="font-semibold text-[var(--fr-primary-dark)] hover:underline">
            {INFO_EMAIL}
          </a>
          .
        </div>
      </div>
    </article>
  );
};

export default Legal;
